<template>
  <div class="contact-cta-area bg-optional ptb-115">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-7 mb-lg-0 mb-4">
          <h6 class="fs-16 fw-normal text-para text-white mb-12">{{ subtitle }}</h6>
          <h2 class="section-title style-one fw-semibold ls-n2 text-white mb-20">
            {{ title }}
          </h2>
          <p class="text-white fs-18 mb-0" v-if="description">
            {{ description }}
          </p>
        </div>
        <div class="col-lg-5 text-lg-end">
          <router-link
            to="/contact"
            class="btn style-two d-inline-flex flex-wrap align-items-center transition"
          >
            <span class="btn-text d-flex flex-column align-items-center justify-content-center transition">
              {{ buttonText }}
            </span>
            <span class="btn-icon d-flex flex-column align-items-center justify-content-center transition">
              <img :src="rightArrowIcon" alt="Icon" />
            </span>
          </router-link>
        </div>
      </div>
      
      <!-- Contact Info Cards -->
      <div class="row mt-55" v-if="showContactInfo">
        <div class="col-lg-4 col-md-6 mb-4" v-if="contactPhone">
          <div class="contact-info-card bg-white round-20 p-30 text-center h-100">
            <div class="contact-icon mb-20">
              <i class="ri-phone-line fs-40 text-primary"></i>
            </div>
            <h5 class="fs-20 fw-semibold mb-15">Call Us</h5>
            <a :href="`tel:${contactPhone}`" class="fs-18 text-para">{{ contactPhone }}</a>
          </div>
        </div>
        
        <div class="col-lg-4 col-md-6 mb-4" v-if="contactEmail">
          <div class="contact-info-card bg-white round-20 p-30 text-center h-100">
            <div class="contact-icon mb-20">
              <i class="ri-mail-line fs-40 text-primary"></i>
            </div>
            <h5 class="fs-20 fw-semibold mb-15">Email Us</h5>
            <a :href="`mailto:${contactEmail}`" class="fs-18 text-para">{{ contactEmail }}</a>
          </div>
        </div>
        
        <div class="col-lg-4 col-md-6 mb-4" v-if="address">
          <div class="contact-info-card bg-white round-20 p-30 text-center h-100">
            <div class="contact-icon mb-20">
              <i class="ri-map-pin-line fs-40 text-primary"></i>
            </div>
            <h5 class="fs-20 fw-semibold mb-15">Visit Us</h5>
            <p class="fs-18 text-para mb-0">{{ address }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useSiteDefaultsStore } from '@/stores/siteDefaultsStore'
import rightArrowIcon from '@/assets/img/icons/right-arrow.svg'

export default {
    name: 'ContactSection',
    data() {
        return {
            subtitle: 'Get In Touch',
            title: 'Ready to discuss your legal needs?',
            description: 'Contact us today for a consultation and let us help you navigate your legal challenges.',
            buttonText: 'Contact Us',
            showContactInfo: true,
            rightArrowIcon
        }
    },
    computed: {
        siteDefaultsStore() {
            return useSiteDefaultsStore()
        },
        contactPhone() {
            return this.siteDefaultsStore.getContactPhone() || ''
        },
        contactEmail() {
            return this.siteDefaultsStore.getContactEmail() || ''
        },
        address() {
            return this.siteDefaultsStore.getAddress() || ''
        }
    },
    async mounted() {
        await this.loadSectionSettings()
    },
    methods: {
        async loadSectionSettings() {
            try {
                const response = await this.$api.get('public/settings?section=home')
                if (response.data && response.data.status === 'success') {
                    const data = response.data.data
                    
                    if (data.contact_cta_subtitle) {
                        this.subtitle = data.contact_cta_subtitle
                    }
                    if (data.contact_cta_title) {
                        this.title = data.contact_cta_title
                    }
                    if (data.contact_cta_description) {
                        this.description = data.contact_cta_description
                    }
                    if (data.contact_cta_button_text) {
                        this.buttonText = data.contact_cta_button_text
                    }
                }
            } catch (error) {
                console.error('Failed to load section settings:', error)
            }
        }
    }
}
</script>

<style scoped>
.contact-info-card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.contact-info-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.contact-icon {
    display: inline-block;
}

.contact-info-card a {
    text-decoration: none;
    transition: color 0.3s ease;
}

.contact-info-card a:hover {
    color: var(--bs-primary) !important;
}
</style>

